import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { LogoStrip } from '../components/landing/LogoStrip';
import { WhatWeDo } from '../components/landing/WhatWeDo';
import { Values } from '../components/landing/Values';
import { AITools } from '../components/landing/AITools';
import { ContactCTA } from '../components/landing/ContactCTA';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--bg)',
    color: 'var(--text)'
  }} data-id="element-76">
      <Navbar data-id="element-77" />
      <Hero data-id="element-78" />
      <LogoStrip data-id="element-79" />
      <WhatWeDo data-id="element-80" />
      <AITools data-id="element-81" />
      <Values data-id="element-82" />
      <ContactCTA data-id="element-83" />
      <Footer data-id="element-84" />
    </div>;
}